import React from 'react'

export default function LaserDevice() {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-20 animate-on-scroll" style={{ backgroundColor: 'var(--medispa-aloe)' }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: 'var(--medispa-olive)' }}>
              Laserski sustav DEKA Again Elite
            </h2>
            <p className="text-lg mb-4" style={{ color: 'var(--medispa-text-grey)' }}>
              U MediSpa Rijeka koristimo <strong>DEKA Again Elite</strong> — medicinski, vrhunski laserski sustav osmišljen za sigurno, učinkovito i praktički bezbolno uklanjanje dlačica.
            </p>
            <ul className="space-y-3 text-[#1a1a1a]">
              <li className="flex items-start">
                <span className="mr-3 text-[#2c3424] font-bold">✓</span>
                <span>Napredna aleksandritska laserska tehnologija</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-[#2c3424] font-bold">✓</span>
                <span>Integrirani ICE sustav hlađenja za udobnost</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-[#2c3424] font-bold">✓</span>
                <span>Prikladno za većinu tipova kože</span>
              </li>
              <li className="flex items-start">
                <span className="mr-3 text-[#2c3424] font-bold">✓</span>
                <span>Odobreno od FDA-e i klinički dokazano</span>
              </li>
            </ul>
          </div>
          <div className="flex justify-center laser-device-image">
            <img 
              src="https://static.lumi.new/01/019f17c9020a6b10219adb6baf39540b.webp" 
              alt="Laserski uređaj DEKA Again Elite"
              className="w-full max-w-md object-cover hover-lift"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  )
}